import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SectionWrapper = styled.section`
  padding: 8rem 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.text.inverse};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 3rem;
  text-align: center;
  
  @media (max-width: 1024px) {
    padding: 0 2rem;
  }
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 2.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: white;
  margin-bottom: 4rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 3rem;
  }
`;

const StatsGrid = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 3rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 3rem;
  }
`;

const StatItem = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const StatNumber = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 4rem;
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  line-height: 1;
`;

const StatLabel = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  opacity: 0.9;
`;

const StatsSection = () => {
    return (
        <SectionWrapper>
            <Container>
                <Title>Impact by the Numbers</Title>
                <StatsGrid>
                    <StatItem
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        <StatNumber>99%</StatNumber>
                        <StatLabel>Accuracy Rate</StatLabel>
                    </StatItem>

                    <StatItem
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                    >
                        <StatNumber>24/7</StatNumber>
                        <StatLabel>Continuous Monitoring</StatLabel>
                    </StatItem>

                    <StatItem
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        <StatNumber>0</StatNumber>
                        <StatLabel>Privacy Breaches</StatLabel>
                    </StatItem>
                </StatsGrid>
            </Container>
        </SectionWrapper>
    );
};

export default StatsSection;
